import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('firebase_id_token');
  return token ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
